<template>
  <v-dialog
      v-model="dialog"
      :width="dialogWidth"
      @keydown.enter.prevent="onenter"
  >
    <v-card
        class="resizable-card"
        :class="{ 'no-select': resizing }"
        :style="{ height: dialogHeight + 'px' }"
    >
      <v-card-title>
        <span class="headline">Reward Package</span>
        <v-spacer/>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="6" sm="6">
            <v-text-field label="Name:" v-model.trim="model.name" hide-details/>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <v-text-field label="Key:" v-model.trim="model.key" hide-details/>
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" class="pt-5">
            <v-checkbox v-model="model.silent" class="mx-1 mt-0" label="Silent Mode" hide-details/>
          </v-col>
        </v-row>
        <v-expansion-panels>
          <r-guard-panel :model.sync="model.guard"/>
          <r-reward-panel :model.sync="model.reward" title="Rewards"/>
          <r-product-panel :items.sync="model.products" title="Products"/>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions class="resizable-card__actions">
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
      <div class="resize-handle" @mousedown="startResize"></div>
    </v-card>
  </v-dialog>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {PackageModel} from "@/modules/redactor/models/package/PackageModel";

import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel";
import RRewardPanel from "@/modules/redactor/views/reward/r-reward-panel.vue";
import RProductPanel from "@/modules/redactor/views/product/r-product-panel.vue";

export default {
  name: "r-package-dialog",
  components: {RProductPanel, RRewardPanel, RGuardPanel},

  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: VueTypes.objectOf(PackageModel),
    rules: ViewRules.READONLY,
    dialogWidth: 575,
    dialogHeight: 416,
    resizing: false,
    resizeStartX: 0,
    resizeStartY: 0,
    resizeStartWidth: 575,
    resizeStartHeight: 416,
    viewportPadding: 32
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new PackageModel();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
      this.stopResize();
    },
    onenter() {
      this.save();
    },
    startResize(e) {
      this.resizing = true;
      this.resizeStartX = e.clientX;
      this.resizeStartY = e.clientY;
      this.resizeStartWidth = this.dialogWidth;
      this.resizeStartHeight = this.dialogHeight;
      window.addEventListener("mousemove", this.onResize);
      window.addEventListener("mouseup", this.stopResize);
    },
    onResize(e) {
      if (!this.resizing) return;
      const dx = e.clientX - this.resizeStartX;
      const dy = e.clientY - this.resizeStartY;
      let newWidth = this.resizeStartWidth + dx;
      let newHeight = this.resizeStartHeight + dy;
      const minWidth = 420;
      const minHeight = 260;
      if (newWidth < minWidth) newWidth = minWidth;
      if (newHeight < minHeight) newHeight = minHeight;
      this.dialogWidth = newWidth;
      this.dialogHeight = newHeight;
    },
    stopResize() {
      if (!this.resizing) return;
      this.resizing = false;
      window.removeEventListener("mousemove", this.onResize);
      window.removeEventListener("mouseup", this.stopResize);
    }
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.onResize);
    window.removeEventListener("mouseup", this.stopResize);
  }
};
</script>

<style lang="css" scoped>
:read-only {
  white-space: nowrap;
}
.resizable-card {
  position: relative;
  display: flex;
  flex-direction: column;
}
.resizable-card__actions {
  flex-shrink: 0;
}
.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 14px;
  height: 14px;
  cursor: se-resize;
  border-right: 2px solid rgba(0, 0, 0, 0.3);
  border-bottom: 2px solid rgba(0, 0, 0, 0.3);
}
.no-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>